const urlmap = {
    getlist: 'urlmap/getlist',
    add: 'urlmap/add',
    update: 'urlmap/update',
    remove: 'urlmap/remove',
    get: 'urlmap/get',
}
export default urlmap
